(function($) {

	jQuery.validator.addMethod("dateDE", function(value, element) {
		return this.optional(element) || /^\d\d?\.\d\d?\.\d\d\d?\d?$/.test(value);
	}, "Bitte geben Sie ein gültiges Datum ein.");

	jQuery.validator.addMethod("numberDE", function(value, element) {
		return this.optional(element) || /^-?(?:\d+|\d{1,3}(?:\.\d{3})+)(?:,\d+)?$/.test(value);
	}, "Bitte geben Sie eine gültige Zahl ein.");

    jQuery.validator.addMethod("placeholder", function(value, element) {
      return value!=$(element).attr("placeholder");
    }, jQuery.validator.messages.required);

})(jQuery);